export default {
  common: {
    currentLanguage: 'A linguagem atual é \'{{lng}}\'',
    email: 'Correio eletrônico',
    password: 'Senha',
    edit: 'ÉditAr',
    update: 'Editar perfil',
    cancel: 'Cancelar',
    delete: 'Remover'
  },
  home: {
    logout: 'Desconexão'
  },
  auth: {
    notRegistered: 'Não registrado?',
    forgotPassword: 'Perdi minha senha',
    forgotPasswordContent: 'Introduza o seu e-mail GOWOD, ser-lhe-á enviada uma palavra-passe temporária que lhe permitirá iniciar sessão.\nNão se esqueça de a alterar nas definições da aplicação.',
    localstorageError: 'Parece que os cookies estão bloqueados no seu navegador. Este site só os utiliza para armazenar dados de autenticação, por favor habilite os cookies.',
    signIn: 'Conexão',
    modal: {
      title: 'O registro para GOWOD é do aplicativo para dispositivos móveis',
      content: 'O aplicativo está disponível para Android e iOS'
    },
    signinFacebook: "Conexão com o Facebook",
    signinGoogle: "Conexão com o Google",
  },
  tabs: {
    profile: 'Perfil',
    pdata: 'Dados pessoais',
    premium: 'GOWOD Premium',
    gifts: 'cartões de oferta'
  },
  profile: {
    firstname: 'Primeiro nome',
    lastname: 'Sobrenome',
    age: 'Idade',
    sex: 'Sexo',
    affiliate: 'Afiliado',
    country: 'País',
    birthdate: 'Data de nascimento'
  },
  sex: {
    MALE: 'Homem',
    FEMALE: 'Mulher',
    OTHER: 'Outro'
  },
  pdata: {
    title: 'Os dados pessoais coletados pelo GOWOD pelo seu bom funcionamento são:',
    part1: 'Dados do perfil: nome, nome, idade, sexo, box afiliada e país',
    part2: 'Resultados do teste de mobilidade: respostas, pontuações, perfil configurado',
    part3: 'Os protocolos geradas para fins estatísticos: data, duração escolhida, tipo (pré / pós WOD, diariamente) e movimentos seleccionados',
    manage: 'GESTÃO DE DADOS',
    download: 'Baixe meus dados',
    delete: 'Excluir minha conta',
    deleteModal: {
      title: 'Excluindo a conta GOWOD',
        part1: 'Tem certeza de que deseja excluir sua conta do GOWOD?',
        part2: 'Esta ação excluirá sua conta',
        part3: 'definitivo e irreversível',
        part4: 'Nota: se você estiver inscrito através do iTunes, a exclusão de sua conta NÃO Irá DESUBSCRIBIR VOCÊ.',
        part5: 'Siga este link para o ajudar a cancelar a subscrição do iTunes'
    }
  },
  promoTuto: {
    line1: 'Como usar o seu promocódigo " COMMUNITY "?',
    line2: '40 DIAS DE TESTE GRATUITO',
    step1: "Escolha uma das ofertas abaixo",
    step2: 'Clique em subscrever',
    step3: 'Clique em "I have a promocode" (só presente se a primeira inscrição)',
    step4: 'Introduza o seu promocódigo: COMMUNITY',
    step51: 'Cancelar a qualquer momento antes do final do julgamento',
    step52: 'para não ser faturado',
    step53: "se não quiseres continuar",
    warning: "Atenção: Oferta válida apenas no seu primeiro registo"
  },
  premium: {
    authenticatePayment: "Autenticar pagamento",
    seeInvoice: "Resolver a questão",
    premiumUnlocks: 'O GOWOD Premium dá-lhe acesso ao teste de mobilidade mensal que lhe permitirá determinar o eixo de mobilidade mais eficaz em termos de custos para melhorar, assim como todos os protocolos de mobilidade PRE-WOD POST-WOD e Daily, configurado em seu ponto fraco para fazer você progredir de forma eficaz.',
    premiumSlogan: 'Mobilidade fácil e personalizada para você',
    point1: 'Melhore seu desempenho no WOD',
    point2: 'Facilitar a aquisição de uma técnica ótima',
    point3: 'Otimize sua transferência de força',
    point4: 'Acelerar sua recuperação',
    point5: 'Reduza o risco de ferimentos',
    freeTrial: '14 dias de teste gratuito para o primeiro registro',
    monthly: ' Mensal',
    halfYearly: 'Semestral',
    yearly: ' Anual',
    subscribe: 'Subscrever',
    perMonth: '/ mês',
    per6Months: '/ 6 meses',
    perYear: '/ ano',
    subscriptionFrom: 'Inscrito desde',

    pausedUntil: 'Subscrição em pausa até',
    nextBilling: 'Próxima facturação',
    changePlan: 'Plano de mudança',
    confirm: 'Confirme',
    reactivateSub: 'Reativar a assinatura',
    unpauseSub: 'Assinatura do Currículo',
    unpauseText: 'Você está prestes a reiniciar sua assinatura, reinicie o aplicativo GOWOD uma vez feito para ter de volta o acesso ao GOWOD Premium.',
    unpause: 'Reativar',
    break: 'Podes, em vez disso, fazer uma pausa!',
    pauseFor: 'Pausa a sua conta para:',
    oneMonth: '1 Mês',
    twoMonths: '2 Meses',
    threeMonths: '3 Meses',
    pauseText: 'Você não será cobrado durante seu intervalo, sua assinatura e acesso ao GOWOD Premium serão retomados no final deste período. Você também pode retomar a assinatura quando quiser.',
    pauseSub: 'Suspender minha assinatura',
    noThanks: 'Não obrigado, cancele a assinatura',

    month: 'mes',
    promocode: 'Código promocional',
    signupDate: 'Data da assinatura',
    accessUntil: 'Acesso a',
    firstBilling: 'Primeiro faturamento',
    currentPeriod: 'Período atual',
    status: 'Estado',
    cancelAtEnd: 'Cancelado no final do período atual',
    changePlanTitle: "Modificar assinatura",
    changePlanContent: "Se estiver num período experimental, este será preservado e o seu novo plano será facturado no final do período experimental.\nCaso contrário, a sua subscrição mudará de plano imediatamente e ser - lhe - á cobrado um valor proporcional pelo novo plano, tendo em conta a parte utilizada do plano antigo.",
    statuses: {
      active: 'Ativos',
      trialing: 'Período experimental atual',
      past_due: 'Problema de pagamento',
      unpaid: 'Problema de pagamento',
      incomplete: 'Autenticação necessária'
    },
    updateCC: 'Atualize o cartão de crédito',
    updateModal: {
      title: 'Atualizar cartão de crédito',
      content: 'Por favor insira as informações do seu novo cartão:'
    },
    unsubscribe: 'Cancelar inscrição',
    successModal: {
      title: "Assinatura bem sucedida!",
      part1: "Parabéns, agora você é um membro GOWOD Premium!",
      part2: "Por favor, feche e reabra a sua aplicação GOWOD para que o seu acesso Premium seja levado em conta."
    },
    unsubModal: {
      title: 'Confirmação de desinscrição',
      part1: 'Você poderia tirar um momento para nos ajudar a melhorar, dizendo-nos por que você está saindo?',
      mail: 'Se tiver algum problema, pode enviar-nos um e-mail directamente para ',
      part2: 'Você terá acesso ao GOWOD Premium até o final do período definido.',
      confirm: 'Confirmar',
      reason1: 'Não o uso o suficiente',
      reason2: 'Demasiado caro',
      reason3: 'Não é suficientemente eficiente',
      reason4: 'Outros',
      addon: "Queres partilhar alguma coisa? (Opcional)"
    },
    storesModal: {
      title: 'Anular subscrição das persianas',
      part1: 'Parece que o seu registro para o GOWOD Premium foi feito através de um dos blinds.',
      part2: 'Você pode cancelar a assinatura da loja correspondente à sua plataforma.',
      part3: 'Você pode verificar esses links se precisar de ajuda:',
    },
    subscribeModal: {
      title: 'Assinatura do GOWOD Premium',
      havePromocode: 'Eu tenho um código promocional',
      validate: 'Validar',
      invalidCode: 'Código inválido',
      validCode1: 'Código válido',
      validCode2: 'dias de teste',
    },
    promocodeModal: {
      link: "Eu tenho um código promocional",
      title: "Uso de um código promocional",
      intro: "Os códigos promocionais permitem-lhe prolongar o período de avaliação da sua assinatura GOWOD Premium.",
      intro2: "Eles só podem ser usados na sua primeira assinatura.",
      step1: "Escolha o faturamento desejado (mensal ou semestral) e clique no botão correspondente",
      step2: "O pop-up de registro é aberto e se esta for sua primeira assinatura, ative o botão de código promocional",
      step3: "Digite seu código no campo e valide com o botão",
      step4: "Se o seu código for válido, você verá uma mensagem de validação confirmando a duração do período de avaliação",
      step5: "Agora você pode preencher seus detalhes de pagamento e continuar seu registro"
    }
  },
  messages: {
    welcome: 'Bem-vindo {{firstname}}',
    error: 'Ocorreu um erro',
    updateOK: 'Atualização bem sucedida!',
    updateKO: 'Ocorreu um erro ao atualizar o perfil',
    subscribeOK: 'Registro para GOWOD Premium com sucesso!',
    subscribeKO: 'Ocorreu um erro ao se inscrever no premium',
    cardInvalid: 'Cartão inválido',
    cardUpdateOK: 'Atualização cartão sucesso',
    cardUpdateKO: 'Ocorreu um erro ao atualizar o cartão de crédito',
    cancelOK: 'Cancelamento da assinatura bem sucedida',
    cancelKO: 'Ocorreu um erro ao cancelar a assinatura',
    premiumInfoKO: 'Ocorreu um erro ao recuperar informações premium',
    deleteKO: 'Ocorreu um erro ao recuperar seus dados pessoais',
    pdataKO: 'Ocorreu um erro ao limpar sua conta',
    wrongCardData: 'Dados do cartão inválidos',
    resetOK: 'Senha temporária enviada',
    pauseOK: 'Pausa na assinatura',
  },
  giftCards: {
    noiTunes: 'Um código de oferta está na forma XXXX-XXXX-XXXX, note que se estiver registado através do iTunes ou Google Play, o código não terá qualquer efeito. <br/>Para saber o procedimento para mudar do iTunes para o nosso site, envie um e-mail para <strong style="color:#6499FF">help@gowod.eu</strong>',
    enterCode: 'Para utilizar o seu cartão oferta, por favor introduza o código:',
    successMessage: 'O seu gato de presente foi aplicado! Reinicie a aplicação e deverá agora ter acesso ao GOWOD Premium.',
    redeem: 'Candidate-se'
  }
}


// WEBPACK FOOTER //
// ./src/languages/pt.js